import VideoCard from "@/components/base/VideoCard";
import type { Video } from "@/types";

interface RelatedListProps {
  videos: Video[];
}

export default function RelatedList({ videos }: RelatedListProps) {
  if (videos.length === 0) {
    return (
      <p className="text-sm text-foreground-500 py-8 text-center">暂无相关推荐，去分类页看看更多内容吧。</p>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
      {videos.map((v, i) => (
        <VideoCard key={v.id} video={v} index={i} />
      ))}
    </div>
  );
}